import React from "react";
import { Card, Col, Row, Typography, Form, Input, Button } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

const { Title, Paragraph, Text } = Typography;

const SUPPORT_EMAIL = "support@crikclips.com";
const SUPPORT_PHONE = "+91 00000 00000";

const PublicSupport = () => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const handleSubmit = (values) => {
    request({
      url: `${apiPath.addSupport}`,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
        form.resetFields();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <div className="policy-public-page">
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} md={20} lg={16}>
          <Card bordered={false} className="policy-public-card">
            <div className="policy-public-header">
              <Text className="policy-public-kicker">Support</Text>
              <Title level={1} className="policy-public-title">
                Need help with CrikClips?
              </Title>
            </div>

            <Row gutter={[24, 24]}>
              <Col xs={24} md={12}>
                <Title level={4}>Contact details</Title>
                <Paragraph>
                  If you have any questions, issues, or feedback about
                  CrikClips, you can reach our support team using the details
                  below or by submitting the form.
                </Paragraph>

                <div style={{ marginTop: 16 }}>
                  <Paragraph>
                    <MailOutlined style={{ marginRight: 8 }} />
                    <Text strong>Email:</Text>{" "}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                  </Paragraph>
                  <Paragraph>
                    <PhoneOutlined style={{ marginRight: 8 }} />
                    <Text strong>Phone:</Text> {SUPPORT_PHONE}
                  </Paragraph>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <Title level={4}>Send us a message</Title>
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={handleSubmit}
                  requiredMark={false}
                >
                  <Form.Item
                    label="Your Name"
                    name="name"
                    rules={[
                      { required: true, message: "Please enter your name" },
                      {
                        max: 100,
                        message: "Name should be under 100 characters",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your name" />
                  </Form.Item>

                  <Form.Item
                    label="Your Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                  >
                    <Input placeholder="Enter your email" />
                  </Form.Item>

                  <Form.Item
                    label="Your Number"
                    name="phone"
                    rules={[
                      { required: true, message: "Please enter your number" },
                      {
                        pattern: /^[0-9+\-\s]{6,20}$/,
                        message: "Please enter a valid phone number",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your phone number" />
                  </Form.Item>

                  <Form.Item
                    label="Your Query"
                    name="message"
                    rules={[
                      { required: true, message: "Please enter your query" },
                      {
                        min: 10,
                        message: "Query should be at least 10 characters",
                      },
                    ]}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="Describe your question or issue"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PublicSupport;
